
export { GenericError } from "/home/runner/work/capsicum/capsicum/libs/common-web/ui/pages/errors/index.ts"